module.exports = __webpack_public_path__ + "static/media/boat-img-11.e0d37450.jpg";